import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const DisclaimerPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page" data-testid="disclaimer-page">
      {/* Block this page from search engines */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Disclaimer - Amatya</title>
      </Helmet>
      
      <div className="legal-container">
        <h1 className="legal-title">Disclaimer</h1>
        <p className="legal-updated">Last Updated: 5th March 2026</p>

        <p className="legal-intro">
          The website www.amatya.co.in and the mobile applications operated under the brand AMATYA (collectively referred to as the "Platform") are owned and operated by ANS Legal and Business Services LLP, having its registered office at C-209, M3M Urbana, Sector 67, Gurgaon, Haryana – 122101, India. This Disclaimer governs the use of the Platform and all services offered through it including Puja Services, Chadhava Seva, Astrology Consultations, Spiritual Guidance, and other related services. By accessing or using the Platform, you agree to the terms of this Disclaimer.
        </p>

        <section className="legal-section">
          <h2>1. Spiritual and Religious Services</h2>
          <p>The services provided on the Platform are based on Sanatana Dharma traditions, Vedic rituals, and spiritual practices. These services may include:</p>
          <ul>
            <li>Online Puja bookings</li>
            <li>Temple offerings (Chadhava)</li>
            <li>Astrology consultations</li>
            <li>Spiritual guidance</li>
            <li>Religious ceremonies performed by priests or astrologers</li>
          </ul>
          <p>All such services are intended to provide spiritual support and guidance. They are not intended to replace professional advice, including but not limited to medical, financial, legal, or psychological advice. Users are encouraged to seek appropriate professional guidance where required.</p>
        </section>

        <section className="legal-section">
          <h2>2. Astrology Disclaimer</h2>
          <p>Astrology is a guidance-based spiritual practice that interprets planetary influences and traditional astrological principles. The predictions, interpretations, or recommendations provided through the Platform:</p>
          <ul>
            <li>Are subjective interpretations</li>
            <li>Are not guaranteed to be accurate</li>
            <li>Should not be considered as definitive outcomes or promises of future events</li>
          </ul>
          <p>AMATYA and its associated astrologers do not guarantee results from astrological consultations. Any decisions taken by users based on such guidance are solely at the user's discretion and responsibility.</p>
        </section>

        <section className="legal-section">
          <h2>3. Rituals and Religious Ceremonies</h2>
          <p>Puja and Chadhava services performed through temples or priests are conducted on a best-efforts basis following customary religious procedures. While every effort is made to ensure proper performance of rituals:</p>
          <ul>
            <li>Exact outcomes or spiritual results cannot be guaranteed</li>
            <li>Ritual practices may vary depending on temple traditions or priestly customs</li>
          </ul>
          <p>AMATYA does not make any representation regarding specific spiritual or material outcomes of such services.</p>
        </section>

        <section className="legal-section">
          <h2>4. No Medical, Legal or Financial Advice</h2>
          <p>The Platform does not provide:</p>
          <ul>
            <li>Medical advice</li>
            <li>Psychological counselling</li>
            <li>Legal advice</li>
            <li>Financial or investment advice</li>
          </ul>
          <p>Any information provided through astrology consultations or spiritual guidance should not be interpreted as professional advice. Users should consult qualified professionals for matters relating to health, law, finance, or other specialized areas.</p>
        </section>

        <section className="legal-section">
          <h2>5. External Temple or Priest Services</h2>
          <p>Some services on the Platform may be carried out by independent temples, priests, astrologers, or third-party service providers. While AMATYA strives to partner with reliable providers, the Platform does not assume liability for:</p>
          <ul>
            <li>Acts or omissions of third-party priests or temples</li>
            <li>Delays caused by external circumstances</li>
            <li>Differences in ritual procedures followed by temples</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Limitation of Liability</h2>
          <p>To the fullest extent permitted by applicable law, ANS Legal and Business Services LLP, its partners, employees, priests, astrologers, and affiliates shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from:</p>
          <ul>
            <li>Use of the Platform</li>
            <li>Reliance on astrology consultations</li>
            <li>Participation in religious services</li>
            <li>Technical interruptions</li>
            <li>Third-party services</li>
          </ul>
          <p>Users agree that use of the Platform is entirely at their own risk.</p>
        </section>

        <section className="legal-section">
          <h2>7. Religious Sensitivity</h2>
          <p>The services offered are rooted in Sanatana Dharma traditions. This does not imply discrimination against or disrespect toward any other religion or belief system. The Platform is intended for individuals who voluntarily wish to participate in such spiritual services.</p>
        </section>

        <section className="legal-section">
          <h2>8. Acceptance of Disclaimer</h2>
          <p>By using the Platform, booking any service, or accessing any content on www.amatya.co.in, you acknowledge that:</p>
          <ul>
            <li>You have read this Disclaimer</li>
            <li>You understand its contents</li>
            <li>You agree to be bound by it</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. Contact Information</h2>
          <p>For any questions regarding this Disclaimer, please contact:</p>
          <div className="legal-contact">
            <p><strong>ANS Legal and Business Services LLP</strong></p>
            <p>C-209, M3M Urbana</p>
            <p>Sector 67, Gurgaon – 122101</p>
            <p>Haryana, India</p>
            <p><strong>Email:</strong> care@amatya.co.in</p>
            <p><strong>Phone:</strong> +91 9711767167</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DisclaimerPage;
